import fetch from 'isomorphic-fetch';
import _get from 'lodash/get';
import { setSiteAlertMessage } from '../../SiteWrapper/modules/site';
import auth from '../../../helpers/auth';
import { setUserDataInState } from '../../login/modules/auth';
import { setAlertMessage } from '../../selectWrapper/modules/select';
import config from '../../../config';

export const SET_ADD_LISTINGS_FORM_DATA = 'SET_ADD_LISTINGS_FORM_DATA';
export const SET_ADD_LISTINGS_SPINNER_STATUS =
  'SET_ADD_LISTINGS_SPINNER_STATUS';
export const SET_ADD_LISTINGS_REGIONS = 'SET_ADD_LISTINGS_REGIONS';
export const SET_ADD_LISTINGS_COUNTRY = 'SET_ADD_LISTINGS_COUNTRY';

export const SET_TIME_ZONE = 'SET_TIME_ZONE';

export const SET_COUNTRY_TIME_ZONE = 'SET_COUNTRY_TIME_ZONE';

export const SET_STATE_TIME_ZONE = 'SET_STATE_TIME_ZONE';
export const SET_ADD_LISTINGS_LABLES = 'SET_ADD_LISTINGS_LABLES';
export const SET_ADD_LISTINGS_CATEGORY = 'SET_ADD_LISTINGS_CATEGORY';
export const UPLOAD_CERTIFICATE = 'UPLOAD_CERTIFICATE';

//---> Fetching userDate and Saving the user data into the redux state

export const setAddListingData = (data) => {
  return {
    type: SET_ADD_LISTINGS_FORM_DATA,
    payload: data,
  };
};

export const setAddListingSpinner = (flag) => {
  return {
    type: SET_ADD_LISTINGS_SPINNER_STATUS,
    payload: flag,
  };
};

export const setListingCategories = (data) => {
  return {
    type: SET_ADD_LISTINGS_CATEGORY,
    payload: data,
  };
};

export const setListingsRegions = (data) => {
  return {
    type: SET_ADD_LISTINGS_REGIONS,
    payload: data,
  };
};

export const setCountryListing = (data) => {
  return {
    type: SET_ADD_LISTINGS_COUNTRY,
    payload: data,
  };
};
export const setTimezoneListing = (data) => {
  return {
    type: SET_TIME_ZONE,
    payload: data,
  };
};
export const setCountryTimeZone = (data) => {
  return {
    type: SET_COUNTRY_TIME_ZONE,
    payload: data,
  };
};
export const setStateTimeZone = (data) => {
  return {
    type: SET_STATE_TIME_ZONE,
    payload: data,
  };
};
export const setListingsLables = (data) => {
  return {
    type: SET_ADD_LISTINGS_LABLES,
    payload: data,
  };
};

export function submitListing(data) {
  return async (dispatch) => {
    await dispatch(addListings(data));
  };
}

export function uploadCertificate(data) {
  return async (dispatch) => {
    await dispatch(uploadCertificateAction(data));
  };
}

export function fetchCategory() {
  return async (dispatch) => {
    try {
      let category = await fetch(`${config.__API__}/get/listing/category`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/drupal.single+json; charset=utf-8',
          Accept: 'application/json',
        },
      });
      let response = await category.json();

      if (!response.success) {
        Object.keys(response.errors).map((item) => {
          dispatch(
            setSiteAlertMessage({
              message: response.errors[item][0],
              color: 'teal',
            })
          );
        });
      } else if (response.success) {
        await dispatch(setListingCategories(response.categories));
      }
    } catch (e) {
      await dispatch(
        setSiteAlertMessage({
          message: 'Server error Please try again.',
          color: 'teal',
        })
      );
      console.log(e);
    }
    //---> Disappearing the Alert Message after 3 sec
    setTimeout(() => {
      dispatch(setSiteAlertMessage({ message: '', color: '' }));
    }, 3000);
  };
}

export function fetchCountry() {
  return async (dispatch) => {
    try {
      let countriesList = await fetch(`${config.__API__}/get/countries`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/drupal.single+json; charset=utf-8',
          Accept: 'application/json',
        },
      });
      let response = await countriesList.json();

      if (!response.success) {
        Object.keys(response.errors).map((item) => {
          dispatch(
            setSiteAlertMessage({
              message: response.errors[item][0],
              color: 'teal',
            })
          );
        });
      } else if (response.success) {
        await dispatch(setCountryListing(response.countries));
      }
    } catch (e) {
      await dispatch(
        setSiteAlertMessage({
          message: 'Server error Please try again.',
          color: 'teal',
        })
      );
      console.log(e);
    }
    //---> Disappearing the Alert Message after 3 sec
    setTimeout(() => {
      dispatch(setAlertMessage({ message: '', color: '' }));
    }, 3000);
  };
}

export function fetchTimeZones() {
  return async (dispatch) => {
    try {
      let timeZoneList = await fetch(`${config.__API__}/get/timezones`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/drupal.single+json; charset=utf-8',
          Accept: 'application/json',
        },
      });
      let response = await timeZoneList.json();

      if (!response.success) {
        Object.keys(response.errors).map((item) => {
          dispatch(
            setSiteAlertMessage({
              message: response.errors[item][0],
              color: 'teal',
            })
          );
        });
      } else if (response.success) {
        await dispatch(setTimezoneListing(response.timezones));
      }
    } catch (e) {
      await dispatch(
        setSiteAlertMessage({
          message: 'Server error Please try again.',
          color: 'teal',
        })
      );
      console.log(e);
    }
    //---> Disappearing the Alert Message after 3 sec
    setTimeout(() => {
      dispatch(setAlertMessage({ message: '', color: '' }));
    }, 3000);
  };
}
export function fetchTimeZoneswithStateName(state_name, updateTimeZoneWithStateName) {
  return async (dispatch) => {
    try {
      let timeZoneList = await fetch(`${config.__API__}/get/timezones/by/state/${state_name}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/drupal.single+json; charset=utf-8',
          Accept: 'application/json',
        },
      });
      let response = await timeZoneList.json();

      if (!response.success) {
        Object.keys(response.errors).map((item) => {
          dispatch(
            setSiteAlertMessage({
              message: response.errors[item][0],
              color: 'teal',
            })
          );
        });
        await dispatch(setStateTimeZone([]));
      } else if (response.success) {
        console.log("responseresponse", response)
        let timezone = response.timezones;

        await dispatch(setStateTimeZone(timezone));
        if (updateTimeZoneWithStateName) {
          updateTimeZoneWithStateName(timezone.length == 1 ? timezone[0].value : '');
        }
      }
    } catch (e) {
      await dispatch(setStateTimeZone([]));
      await dispatch(
        setSiteAlertMessage({
          message: 'Server error Please try again.',
          color: 'teal',
        })
      );
      console.log(e);
    }
    //---> Disappearing the Alert Message after 3 sec
    setTimeout(() => {
      dispatch(setAlertMessage({ message: '', color: '' }));
    }, 3000);
  };
}

export function fetchTimeZoneswithCountryCode(country_code, updateTimezone) {
  if(country_code==null || country_code ==undefined || country_code == ''){
   return;
  }
  return async (dispatch) => {
    try {
      let timeZoneList = await fetch(`${config.__API__}/get/timezones/by/country/${country_code}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/drupal.single+json; charset=utf-8',
          Accept: 'application/json',
        },
      });
      let response = await timeZoneList.json();

      if (!response.success) {
        Object.keys(response.errors).map((item) => {
          dispatch(
            setSiteAlertMessage({
              message: response.errors[item][0],
              color: 'teal',
            })
          );
        });
        await dispatch(setCountryTimeZone([]));
      } else if (response.success) {
        let timezone = response.timezones;

        await dispatch(setCountryTimeZone(timezone));
        if (updateTimezone) {
          updateTimezone(timezone.length == 1 ? timezone[0].value : '');
        }
      }
    } catch (e) {
      await dispatch(setCountryTimeZone([]));
      await dispatch(
        setSiteAlertMessage({
          message: 'Server error Please try again.',
          color: 'teal',
        })
      );
    }
    //---> Disappearing the Alert Message after 3 sec
    setTimeout(() => {
      dispatch(setAlertMessage({ message: '', color: '' }));
    }, 3000);
  };
}
export function fetchRegions(country_id) {
  if(country_id==null || country_id ==undefined || country_id == ""){
    return;
  }
  return async (dispatch) => {
    try {
      let regions_res = await fetch(`${config.__API__}/get/region/by/country/${country_id}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/drupal.single+json; charset=utf-8',
          Accept: 'application/json',
        },
      });
      const response = await regions_res.json();

      if (!response.success) {
        Object.keys(response.errors).map((item) => {
          dispatch(
            setSiteAlertMessage({
              message: response.errors[item][0],
              color: 'teal',
            })
          );
        });
      } else if (response.success) {
        await dispatch(setListingsRegions(response.regions));
      }
    } catch (e) {
      await dispatch(
        setSiteAlertMessage({
          message: 'Server error Please try again.',
          color: 'teal',
        })
      );
      console.log(e);
    }
    //---> Disappearing the Alert Message after 3 sec
    setTimeout(() => {
      dispatch(setAlertMessage({ message: '', color: '' }));
    }, 3000);
  };
}

export function fetchLables() {
  return async (dispatch) => {
    try {
      let lables = await fetch(`${config.__API__}/get/listing/label`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/drupal.single+json; charset=utf-8',
          Accept: 'application/json',
        },
      });
      let response = await lables.json();

      if (!response.success) {
        Object.keys(response.errors).map((item) => {
          dispatch(
            setSiteAlertMessage({
              message: response.errors[item][0],
              color: 'teal',
            })
          );
        });
      } else if (response.success) {
        await dispatch(setListingsLables(response.labels));
      }
    } catch (e) {
      await dispatch(
        setSiteAlertMessage({
          message: 'Server error Please try again.',
          color: 'teal',
        })
      );
      console.log(e);
    }
    //---> Disappearing the Alert Message after 3 sec
    setTimeout(() => {
      dispatch(setAlertMessage({ message: '', color: '' }));
    }, 3000);
  };
}

export function addListings(data) {
  return async (dispatch) => {
    let bodyData = {
      params: data,
    };

    await dispatch(setAddListingSpinner(true));
    try {
      let result = await fetch(`${config.__API__}/add/listing`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify(bodyData),
      });
      let response = await result.json();
      if (!response.success) {
        Object.keys(response.errors).map((item) => {
          dispatch(
            setSiteAlertMessage({
              message: response.errors[item][0],
              color: 'teal',
            })
          );
        });
        await dispatch(setAddListingSpinner(false));
      } else if (response.success) {
        data['listing_id'] = response.listing_id;
        await dispatch(uploadCertificateAction(data));
        await dispatch(setAddListingSpinner(false));
        await dispatch(setUserDataInState(response.user_data));
        await auth.setTokens(response.token, response.user_data.roles.role);
        data.history.push('/welcome');
        await dispatch(
          setAlertMessage({
            message: 'Listing added successfully',
            color: 'green',
          })
        );
      }
    } catch (e) {
      await dispatch(setAddListingSpinner(false));
      await dispatch(
        setSiteAlertMessage({
          message: 'Server error Please try again.',
          color: 'teal',
        })
      );
      console.log(e);
    }
  };
}

export function uploadCertificateAction(data) {
  let formData = new FormData();
  formData.append('insuranceCertificate', data['insuranceCertificate']);
  formData.append('businessCertificate', data['businessCertificate']);
  formData.append('listing_id', data['listing_id']);
  return async (dispatch) => {
    await dispatch(setAddListingSpinner(true));
    try {
      let result = await fetch(`${config.__API__}/upload/certificate`, {
        method: 'POST',
        body: formData,
      });
      let response = await result.json();
      if (!response.success) {
        Object.keys(response.errors).map((item) => {
          dispatch(
            setSiteAlertMessage({
              message: response.errors[item][0],
              color: 'teal',
            })
          );
        });
        await dispatch(setAddListingSpinner(false));
      } else if (response.success) {
        console.log(response);
      }
    } catch (e) {
      await dispatch(setAddListingSpinner(false));
      await dispatch(
        setSiteAlertMessage({
          message: 'Server error Please try again.',
          color: 'teal',
        })
      );
      console.log(e);
    }
  };
}

export const actions = {
  setAddListingData,
  setSiteAlertMessage,
  setAddListingSpinner,
  setListingCategories,
  setListingsLables,
  setListingsRegions,
  setCountryListing,
  setTimezoneListing,
  setCountryTimeZone,
  setStateTimeZone,
  fetchCategory,
  fetchLables,
  fetchRegions,
  fetchCountry,
  fetchTimeZones,
  fetchTimeZoneswithCountryCode,
  fetchTimeZoneswithStateName,
  addListings,
  submitListing,
  uploadCertificate,
};

const initialState = {
  listingData: {
    email: '',
    name: '',
    password: '',
    c_password: '',
    listing_name: '',
    location: '',
    contact_email_or_url: '',
    description: '',
    listing_category: '',
    listing_region: '',
    listing_label: [],
    cover_img: '',
    gallery_images: [],
    timezone: '',
    website: '',
    phone: '',
    video_url: '',
    lattitude: '',
    longitude: '',
    insurance_certificate: '',
    business_certificate: '',
  },
  addListingSpinner: false,
  categories: [],
  lables: [],
  regions: [],
  country: [],
  timeZoneList: [],
  countryTimeZoneList: [],
  stateTimeZoneList: [],
  submit_listing: false,
};

const ACTION_HANDLERS = {
  [SET_TIME_ZONE]: (state, action) => {
    //console.log(action.payload);
    return {
      ...state,
      timeZoneList: action.payload,
    };
  },
  [SET_COUNTRY_TIME_ZONE]: (state, action) => {
    //console.log(action.payload);
    return {
      ...state,
      countryTimeZoneList: action.payload,
    };
  },
  [SET_STATE_TIME_ZONE]: (state, action) => {
    //console.log(action.payload);
    return {
      ...state,
      stateTimeZoneList: action.payload,
    };
  },

  [SET_ADD_LISTINGS_FORM_DATA]: (state, action) => {
    //console.log(action.payload);
    return {
      ...state,
      listingData: action.payload,
    };
  },
  [SET_ADD_LISTINGS_SPINNER_STATUS]: (state, action) => {
    return {
      ...state,
      addListingSpinner: action.payload,
    };
  },
  [SET_ADD_LISTINGS_CATEGORY]: (state, action) => {
    for (var i = 0; i < action.payload.length; i++) {
      action.payload[i].label = action.payload[i]['category_name'];
      action.payload[i].value = action.payload[i]['id'];
      delete action.payload[i].category_name;
      delete action.payload[i].id;
    }
    return {
      ...state,
      categories: action.payload,
    };
  },
  [SET_ADD_LISTINGS_LABLES]: (state, action) => {
    for (var i = 0; i < action.payload.length; i++) {
      action.payload[i].label = action.payload[i]['label_name'];
      action.payload[i].value = action.payload[i]['id'];
      delete action.payload[i].label_name;
      delete action.payload[i].id;
    }
    action.payload.push({ label: 'Other', value: '0' });
    return {
      ...state,
      lables: action.payload,
    };
  },
  [SET_ADD_LISTINGS_REGIONS]: (state, action) => {
    for (var i = 0; i < action.payload.length; i++) {
      action.payload[i].label = action.payload[i]['region_name'];
      action.payload[i].value = action.payload[i]['id'];
      delete action.payload[i].region_name;
      delete action.payload[i].id;
    }
    return {
      ...state,
      regions: action.payload,
    };
  },
  [SET_ADD_LISTINGS_COUNTRY]: (state, action) => {
    for (var i = 0; i < action.payload.length; i++) {
      action.payload[i].label = action.payload[i]['name'];
      action.payload[i].value = action.payload[i]['id'];
      delete action.payload[i].name;
      delete action.payload[i].id;
    }
    return {
      ...state,
      country: action.payload,
    };
  },
};

export default function AddListingReducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
}



// WEBPACK FOOTER //
// ./src/routes/AddListings/modules/AddListings.js